import { ImTwitter, ImWhatsapp, ImGithub, ImFacebook } from "react-icons/im";
import { FaTelegramPlane } from "react-icons/fa";
import { Link } from "react-router-dom";
// import { useRecoilValue } from "recoil";
// import { barreDefilement } from "../services/atom";
import Carousel from "./Carousel";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import { client } from "../client";
// import HeaderScroll from "./HeaderScroll";

const Header = () => {
  // const hauteurScroll = useRecoilValue(barreDefilement);
  const [age, setAge] = useState("")

  useEffect(() => {
    client
      .fetch(
        `*[_type == 'Age'] {
          annee,
            mois
        }`
      )
      .then((data) => {
        setAge(data[0]);
        console.log(data[0]);
      })
      .catch(console.error);
  }, [])

  return (
    <div className="flex w-full lg:w-[450px] lg:h-screen lg:max-w-[450px] lg:bg-[#1f2d32] overflow-hidden">
      <div className="w-full relative bg-[#1f2d32] font-[yanone-regular] max-h-screen lg:max-h-screen lg:w-[450px] lg:h-screen lg:col-span-5 xl:col-span-4 flex flex-col lg:fixed">
        <div
          className="flex h-[50vh] w-full overflow-hidden relative 
        before:content-[''] before:absolute before:z-20 before:-left-8 
        before:-right-8 before:-bottom-[6.72rem] before:h-40 
        before:bg-[#1f2d32] before:rounded-tl-[100%] 
        before:rounded-tr-[100%]"
        >
          <Carousel />
        </div>

        <div
          className={`w-full h-[50vh] lg:h-[40vh] flex flex-col items-center`}
        >
          <div className={`z-30 flex items-center space-x-2 lg:space-x-0 `}>
            <img
              src={process.env.PUBLIC_URL + "/images/profil-1.jpg"}
              alt="profile"
              className={`rounded-full object-cover transition-all z-40 border-[#1f2d32] border-4 w-40 h-40 mobile-m:w-52 mobile-m:h-52 -translate-y-32 mobile-m:-translate-y-36 lg:-translate-y-36
             `}
            />
          </div>
          <div
            className={` lg:-translate-y-32 flex flex-col font-[Yanone Kaffeesatz] items-center text-white -translate-y-28 md:-translate-y-32 `}
          >
            <div className="flex -space-x-1 md:-space-x-2 items-center text-4xl text-[#c3e88d] tracking-tighter font-semibold md:text-6xl">
              <span className="">
                <img
                  className="h-11 w-11 md:h-14 md:w-14"
                  src={process.env.PUBLIC_URL + "/logo-portfolio-a.svg"}
                  alt="logo"
                />
              </span>
              <span className="text-sous-titre-vert mt-2.5 md:mt-1.5">mara Fofana</span>
            </div>
            <p className="text-3xl">
              <span className="text-sous-titre-rouge text-[#f77669] font-bold">{age.annee}</span>
              ({age.mois})
            </p>
            <span className="text-sous-titre-bleu text-5xl text-[#82aac1] pb-2">
              dévéloppeur web
            </span>
            <ul className="flex space-x-3">
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/Amarafofana_web"
                  // className="text-[#c3e88d] text-lg italic font-bold"
                >
                  <ImTwitter className="h-7 w-7" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://wa.me/+2250554771447"
                  // className="text-[#c3e88d] text-lg italic font-bold"
                >
                  <ImWhatsapp className="h-7 w-7" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/amara121"
                  // className="text-[#c3e88d] text-lg italic font-bold"
                >
                  <ImGithub className="h-7 w-7" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/profile.php?id=100051594900772"
                  // className="text-[#c3e88d] text-lg italic font-bold"
                >
                  <ImFacebook className="h-7 w-7" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://t.me/Parzival00007"
                  // className="text-[#c3e88d] text-lg italic font-bold"
                >
                  <FaTelegramPlane className="h-7 w-7" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex-1 hidden lg:flex items-end justify-center pb-2">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Header;
